export interface IEmploymentForm {
  code: number
  pl: string
  en: string
  [key: string]: string | number
}

const employmentForms: IEmploymentForm[] = [
  {
    code: 1,
    pl: 'Umowa zlecenie / umowa o dzieło',
    en: 'Contract of mandate / specific work'
  },
  {
    code: 2,
    pl: 'Firma',
    en: 'Company'
  },
  {
    code: 3,
    pl: 'Umowa o pracę',
    en: 'Employment Contract'
  },
  {
    code: 4,
    pl: 'Jednoosobowa działalność gospodarcza',
    en: 'Sole proprietorship'
  },
  {
    code: 5,
    pl: 'Praca za granicą',
    en: 'Employment abroad'
  },
  {
    code: 6,
    pl: 'Brak stałego miejsca pracy',
    en: 'No permanent place of work'
  }
]

export default employmentForms
